export interface NavigationItem {
  id: string;
  title: string;
  type: 'item' | 'group';
  icon: string;
  url?: string;
  onClick?: string;
  static?: boolean;
  target?: string;
  badge?: {
    title: string;
    bg: string;
    fg: string;
    classes: string;
  };
}

export const merchantNavigation: NavigationItem[] = [
  {
    id: 'merchant-get-started',
    title: 'Get Started!',
    type: 'item',
    icon: 'custom-icons:rocket_launch',
    onClick: 'openMerchantSupportPopup',
    static: true,
  },
  {
    id: 'merchant-dashboard-component',
    title: 'Dashboard',
    type: 'item',
    icon: 'material-outline:space_dashboard',
    url: '/merchant/dashboard',
  },
  {
    id: 'merchant-offers-component',
    title: 'Offers',
    type: 'item',
    icon: 'material-outline:article',
    url: '/merchant/offers',
  },
  {
    id: 'merchant-business-component',
    title: 'Business Profile',
    type: 'item',
    icon: 'material-outline:work_outline',
    url: '/merchant/profile',
  },
  {
    id: 'support-component',
    title: 'Support',
    type: 'item',
    icon: 'material-outline:support',
    url: 'merchant/support',
  },
];

export const processorNavigation: NavigationItem[] = [
  {
    id: 'merchant-dashboard-component',
    title: 'Dashboard',
    type: 'item',
    icon: 'material-outline:space_dashboard',
    url: '/processor/dashboard',
  },
  {
    id: 'leads-component',
    title: 'Leads',
    type: 'item',
    icon: 'material-outline:assignment',
    url: 'processor/leads',
  },
  {
    id: 'offers-component',
    title: 'Offers',
    type: 'item',
    icon: 'material-outline:article',
    url: 'processor/offers',
  },
  {
    id: 'offer-component',
    title: 'Offer Templates',
    type: 'item',
    icon: 'material-outline:a',
    url: 'processor/offer-templates',
  },
  {
    id: 'documents',
    title: 'Documents',
    type: 'item',
    icon: 'material-outline:documents',
    url: 'processor/documents',
  },
  {
    id: 'profile-component',
    title: 'Profile',
    type: 'item',
    icon: 'material-outline:account_circle',
    url: 'processor/profile',
  },
  {
    id: 'support-component',
    title: 'Support',
    type: 'item',
    icon: 'material-outline:support',
    url: 'processor/support',
  },
  {
    id: 'preferences-component',
    title: 'Preferences',
    type: 'item',
    icon: 'material-outline:settings',
    url: 'processor/preferences',
  },
];

export const adminNavigation: NavigationItem[] = [
  {
    id: 'admin-dashboard-component',
    title: 'Dashboard',
    type: 'item',
    icon: 'material-outline:space_dashboard',
    url: '/admin/dashboard',
  },
  {
    id: 'admin-leads-component',
    title: 'Leads',
    type: 'item',
    icon: 'material-outline:assignment',
    url: '/admin/leads',
  },
  {
    id: 'admin-merchant-component',
    title: 'Merchant',
    type: 'item',
    icon: 'material-outline:database',
    url: '/admin/merchant',
  },
  {
    id: 'admin-processor-component',
    title: 'Processor',
    type: 'item',
    icon: 'material-outline:check_list',
    url: '/admin/processor',
  },
  {
    id: 'admin-grouped-offers-component',
    title: 'Offers',
    type: 'item',
    icon: 'material-outline:article',
    url: '/admin/offers',
  },
  {
    id: 'admin-rebates-component',
    title: 'Rebates',
    type: 'item',
    icon: 'heroicons-outline:percent-badge',
    url: '/admin/rebates',
  },
  {
    id: 'admin-resubmit-requests-component',
    title: 'Resubmit Requests',
    type: 'item',
    icon: 'material-outline:text_snippet',
    url: '/admin/resubmit-requests',
  },
  {
    id: 'admin-agents-component',
    title: 'Agents',
    type: 'item',
    icon: 'material-outline:supervisor_account',
    url: '/admin/agents',
  },
  {
    id: 'admin-affiliate-leads-component',
    title: 'Affiliate Leads',
    type: 'item',
    icon: 'material-outline:table_view',
    url: '/admin/affiliate-leads',
  },
  {
    id: 'admin-ai-call-agent-history',
    title: 'AI Call Agent History',
    type: 'item',
    icon: 'material-outline:history',
    url: 'https://dashboard.retellai.com/callHistory',
    target: '_blank',
  },
  {
    id: 'admin-zoho-crm',
    title: 'ZohoCRM',
    type: 'item',
    icon: 'material-outline:business',
    url: 'https://crmplus.zoho.com/payblox/index.do/cxapp/crm/org817091473/tab/Home/begin',
    target: '_blank',
  },
];

export const agentNavigation: NavigationItem[] = [
  {
    id: 'agent-dashboard-component',
    title: 'Dashboard',
    type: 'item',
    icon: 'material-outline:space_dashboard',
    url: '/agent/dashboard',
  },
  {
    id: 'admin-leads-component',
    title: 'Leads',
    type: 'item',
    icon: 'material-outline:assignment',
    url: '/agent/leads',
  },
  {
    id: 'admin-tools-component',
    title: 'Tools',
    type: 'item',
    icon: 'heroicons-outline:wrench-screwdriver',
    url: '/agent/tools',
  },
  {
    id: 'support-component',
    title: 'Support',
    type: 'item',
    icon: 'material-outline:support',
    url: 'agent/support',
  },
];

export const managerNavigation: NavigationItem[] = [
  {
    id: 'manager-dashboard-component',
    title: 'Dashboard',
    type: 'item',
    icon: 'material-outline:space_dashboard',
    url: '/manager/dashboard',
  },
  {
    id: 'manager-leads-component',
    title: 'Leads',
    type: 'item',
    icon: 'material-outline:assignment',
    url: '/manager/leads',
  },
  {
    id: 'manager-merchant-component',
    title: 'Merchant',
    type: 'item',
    icon: 'material-outline:database',
    url: '/manager/merchants',
  },
  {
    id: 'manager-processor-component',
    title: 'Processor',
    type: 'item',
    icon: 'material-outline:check_list',
    url: '/manager/processors',
  },
  {
    id: 'manager-grouped-offers-component',
    title: 'Offers',
    type: 'item',
    icon: 'material-outline:article',
    url: '/manager/offers',
  },
  {
    id: 'manager-rebates-component',
    title: 'Rebates',
    type: 'item',
    icon: 'heroicons-outline:percent-badge',
    url: '/manager/rebates',
  },
  {
    id: 'manager-resubmit-requests-component',
    title: 'Resubmit Requests',
    type: 'item',
    icon: 'material-outline:text_snippet',
    url: '/manager/resubmit-requests',
  },
  {
    id: 'manager-agents-component',
    title: 'Agents',
    type: 'item',
    icon: 'material-outline:supervisor_account',
    url: '/manager/agents',
  },
  {
    id: 'manager-affiliate-leads-component',
    title: 'Affiliate Leads',
    type: 'item',
    icon: 'material-outline:table_view',
    url: '/manager/affiliate-leads',
  },
];
